import { getAmplitudeInstance } from '../amplitudeHelpers';
import MapDrawerLocation from '../enums/MapDrawerLocation';
import MapLocation from '../enums/MapLocation';

type logMapLayerDrawerTabTappedParams = {
  map_location: MapLocation;
  to_map_tab: MapDrawerLocation;
};

/**
 * User switches between tabs in the map layer drawer.
 * @param params - Attributes to log with the amplitude event
 * @param params.map_location - The location of the map where the interaction occurred
 * @param params.to_map_tab - The drawer tab that the user selected.
 */
const logMapLayerDrawerTabTapped = ({ map_location, to_map_tab }: logMapLayerDrawerTabTappedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('map layer drawer tab tapped', { 'map location': map_location, 'to map tab': to_map_tab }, callback);
};

export default logMapLayerDrawerTabTapped;
